import React from "react";
import styled from "styled-components";
import Link from "next/link";
import {device} from "../../constants/media";

const Container = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 1 0 21%;
  box-sizing: border-box;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  user-drag: none;
  user-select: none;
  position: relative;
  overflow: hidden;

  &:hover {
    .photo {
      transform: scale(1.2, 1.2);
      -webkit-filter: grayscale(0);
      filter: none;
    }

    .name {
      opacity: 1;
    }
  }

  @media ${device.below.laptopL} {
    flex: 1 0 33.3%;
  }

  @media ${device.below.tablet} {
    flex: 1 0 50%;
  }

  @media ${device.below.mobileL} {
    flex: 1 0 101%;
  }
`;

const PhotoContainer = styled.div`
  width: 100%;
  overflow: hidden;
  transition: border-radius 0.3s;
  box-sizing: border-box;
  user-select: none;
  user-drag: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NameContainer = styled.div`
  @media ${device.below.tablet} {
    opacity: 1;
  }
  opacity: 0;
  font-size: .75rem;
  font-weight: bold;
  color: #231f20;
  text-align: center;
  margin-top: 10px;
  width: 100%;
  height: 20%;
  position: absolute;
  bottom: 0;
  background-color: rgb(0 0 0 / 0.7);
  transition: background-color 0.3s;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: rgb(255 255 255 / 0.7);
    color: #000;
  }
`;

const Photo = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
  transition: all 0.3s;

  filter: gray; /* IE6-9 */
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
`;

class WorkItem extends React.Component {
  render() {
    const work = this.props.work;
    return (
      <Link href={"/works/" + work.slug} passHref>
        <Container>
          <PhotoContainer>
            <Photo className={"photo"} src={work.cover} />
          </PhotoContainer>
          <NameContainer className={"name"}>{work.title}</NameContainer>
        </Container>
      </Link>
    );
  }
}

export default WorkItem;
